import { lazy } from "react";

/** Eager: default landing + high-traffic member pages stay in the main chunk. */
export { default as LandingPage } from "../comp/LandingPage";
export { default as MessagePage } from "../comp/user/MessagePage";
export { default as ProfilePage } from "../comp/user/ProfilePage";
export { default as SettingsPage } from "../comp/admin/SettingsPage";

/** Lazy-loaded pages — split into separate chunks on navigation. */
export const ManageFamily = lazy(() => import("../comp/user/ManageFamilyPage"));
export const AddChildPage = lazy(() => import("../comp/user/AddChildPage"));
export const MembershipPage = lazy(() => import("../comp/admin/MembershipPage"));
export const DigitalCardPage = lazy(() => import("../comp/user/DigitalCardPage"));
export const BoardPage = lazy(() => import("../comp/board/BoardPage"));
export const DocumentationPage = lazy(() => import("../comp/user/DocumentationPage"));
export const MembersGroupAddUsersPage = lazy(() => import("../comp/admin/MembersGroupAddUsersPage"));
export const BeltsPage = lazy(() => import("../comp/user/BeltsPage"));
export const PendingPromotionPage = lazy(() => import("../comp/admin/PendingPromotionPage"));
export const ColorPromotionPage = lazy(() => import("../comp/user/ColorPromotionPage"));
export const PendingColorPromotionPage = lazy(() => import("../comp/admin/PendingColorPromotionPage"));
export const MentorListPage = lazy(() => import("../comp/coach/MentorListPage"));
export const MentorManagerPage = lazy(() => import("../comp/admin/MentorManagerPage"));
export const BeltPromotionPage = lazy(() => import("../comp/admin/BeltPromotionPage"));
export const BeltAdminPage = lazy(() => import("../comp/admin/BeltAdminPage"));
export const PromotionByGroupPage = lazy(() => import("../comp/admin/PromotionByGroupPage"));
export const ClubSettingsPage = lazy(() => import("../comp/admin/ClubSettingsPage"));
export const UserAdminPage = lazy(() => import("../comp/admin/UserAdminPage"));
export const AttendancePage = lazy(() => import("../comp/user/AttendancePage"));
export const AchievementsPage = lazy(() => import("../comp/user/AchievementsPage"));
export const MyPaymentsPage = lazy(() => import("../comp/user/MyPaymentsPage"));
export const MyMentorPage = lazy(() => import("../comp/user/MyMentorPage"));
export const MySmiliesPage = lazy(() => import("../comp/user/MySmiliesPage"));
export const ClubAttendanceStats = lazy(() => import("../comp/admin/ClubAttendanceStatsPage"));
export const QRScannerPage = lazy(() => import("../comp/admin/QRScannerPage"));
export const SchedulePage = lazy(() => import("../comp/admin/SchedulePage"));
export const ScheduleHubPage = lazy(() => import("../comp/admin/ScheduleHubPage"));
export const InstructorSchedulePage = lazy(() => import("../comp/admin/InstructorSchedulePage"));
export const InstructorAvailabilityPage = lazy(() => import("../comp/admin/InstructorAvailabilityPage"));
export const QRResultPage = lazy(() => import("../comp/admin/QRResultPage"));
export const TimerPage = lazy(() => import("../comp/admin/TimerPage"));
export const NewContentPage = lazy(() => import("../comp/admin/NewContentPage"));
export const TrainingProgramContentPage = lazy(() => import("../comp/admin/TrainingProgramContentPage"));
export const VideoLibraryContentPage = lazy(() => import("../comp/admin/VideoLibraryContentPage"));
export const NewsPage = lazy(() => import("../comp/user/NewsPage"));
export const NewsDetailPage = lazy(() => import("../comp/user/NewsDetailPage"));
export const TrainingProgramPage = lazy(() => import("../comp/user/TrainingProgramPage"));
export const TrainingProgramDetailPage = lazy(() => import("../comp/user/TrainingProgramDetailPage"));
export const VideoLibraryPage = lazy(() => import("../comp/user/VideoLibraryPage"));
export const TimeRegistrationPage = lazy(() => import("../comp/coach/TimeRegistration"));
export const ApprovalCenterPage = lazy(() => import("../comp/admin/ApprovalCenterPage"));
export const FinancePage = lazy(() => import("../comp/admin/FinancePage"));
export const ExpensesPage = lazy(() => import("../comp/admin/ExpensesPage"));
export const TrainingGroupsPage = lazy(() => import("../comp/admin/TrainingGroupsPage"));
export const GroupMailingsPage = lazy(() => import("../comp/admin/GroupMailingsPage"));
export const LokStodPage = lazy(() => import("../comp/admin/LokStodPage"));
export const AnmalningarPage = lazy(() => import("../comp/admin/AnmalningarPage"));
export const PosAdminPage = lazy(() => import("../comp/admin/PosAdminPage"));
export const PosShopPage = lazy(() => import("../comp/user/PosShopPage"));
export const PosShopCheckoutPage = lazy(() => import("../comp/user/PosShopCheckoutPage"));
export const PosShopKioskPage = lazy(() => import("../comp/user/PosShopKioskPage"));
export const BirthdayDisplayPage = lazy(() => import("../comp/admin/BirthdayDisplayPage"));
